import React, {Component} from 'react';
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import {request} from "../../util/APIUtils";
import Table from "../../components/Table/Table";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import {create_UUID, filterCities, filterSubDivisions, showAxiosError} from "../../util/Helpers";
import {API_BASE_URL} from "../../constants";
import LoadingIndicator from "../../common/LoadingIndicator";
import {Button, Dropdown, Menu} from 'antd';
import Icon from "antd/es/icon";
import IncomeForm from "../financial/IncomeForm";
import "./MemberList.css";
import * as headerContent from "../../constants/exportcontent";
import ExcelDownloadForm from "./ExcelDownloadForm";
import moment from "moment/moment";
import MemberAccrualsModal from "./MemberAccrualsModal";


class PassiveMemberListWithDebit extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedMember: null,
            selectedItem: null,
            branches: null,
            aliasList: null,
            members: [],
            totalIdList: [],
            debtList: [],
            cities: null,
            citySubdivisions: null,
            loading: false,
            searching: false,
            searchQuery: undefined,
            total: 0,
            page: 0,
            size: 10,
            manual: false,
            addMemberModal: false,
            addTransferModal: false,
            addPasswordResetModal: false,
            addAccrualModal: false,
            showTransactionHistoryModal: false,
            showEditAccrualModal: false,
            mode: this.props.location.mode,
            action: '',
            isLoading: false,
            alert: null,
            transactionChannels: [],
            transactionTypes: [],
            memberId: null,
            excelDownloadForm: false,
            subdivisions: []
        };

        this.listMembers = this.listMembers.bind(this);
        this.cancelMemberCreation = this.cancelMemberCreation.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.listCities = this.listCities.bind(this);
        this.listCitySubdivisions = this.listCitySubdivisions.bind(this);
        this.listBranchSubdivisions = this.listBranchSubdivisions.bind(this);
        this.addNew = this.addNew.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleTransfer = this.handleTransfer.bind(this);
        this.listBranches = this.listBranches.bind(this);
        this.handleSendResetPasswordEmail = this.handleSendResetPasswordEmail.bind(this);
        this.handleMenuClick = this.handleMenuClick.bind(this);
        this.handleAccruals = this.handleAccruals.bind(this);
        this.handleTransactionHistory = this.handleTransactionHistory.bind(this);
        this.handleEditAccrual = this.handleEditAccrual.bind(this);
        this.cancelAccrualEditModal = this.cancelAccrualEditModal.bind(this);
    }

    componentDidMount() {
        this.listCities();
        this.listCitySubdivisions();
        this.listBranchSubdivisions();
        this.listBranches();
        this.listIncomeTypes();
        this.listTransactionChannels();
    }

    listIncomeTypes() {
        let self = this;
        let params = {
            url: API_BASE_URL + "/transaction-type/list",
            method: "get",
        };
        request(params)
            .then(function (response) {
                let transactionTypes = response.data;
                self.setState({
                    transactionTypes,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    listTransactionChannels() {
        let self = this;
        let params = {
            url: API_BASE_URL + "/transaction-channel/list",
            method: "get",
        };
        request(params)
            .then(function (response) {
                let transactionChannels = response.data;
                self.setState({
                    transactionChannels,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    listBranches() {
        let self = this;
        let params = {
            url: API_BASE_URL + "/oda/oda-list/",
            method: "get",
        };
        request(params)
            .then(function (response) {
                let branches = response.data;
                self.setState({
                    branches,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    listCities() {
        let self = this;
        let params = {
            // url: API_BASE_URL + "/city/listByBranch/",
            url: API_BASE_URL + "/city",
            //url: API_BASE_URL+"/city/" ,
            method: "get",
        };
        request(params)
            .then(function (response) {
                let cities = response.data;
                self.setState({
                    cities,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    listCitySubdivisions() {
        let self = this;
        let params = {
            url: API_BASE_URL + "/city-subdivision",
            method: "get",
        };
        request(params)
            .then(function (response) {
                let citySubdivisions = response.data;
                self.setState({
                    citySubdivisions,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    listBranchSubdivisions() {
        let self = this;
        let params = {
            url: API_BASE_URL + "/city-subdivision/filterByBranch",
            method: "get",
        };
        request(params)
            .then(function (response) {
                let subdivisions = response.data;
                self.setState({
                    subdivisions,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    listMembers(accessor, direction, page, size) {
        let self = this;
        let sortStr = !!accessor ? ("&sort=" + accessor + ',' + direction) : "&sort=id,asc";
        let searchQuery = !self.state.searchQuery ? '&borcuVar=true' : '&borcuVar=true&' + self.state.searchQuery;
        let url = API_BASE_URL + "/uye/fetchApprovedMemberByBranch?page=" + page + "&size=" + size + sortStr + searchQuery;


        let params = {
            url: url,
            method: "get",
        };
        self.setState({loading: true, manual: self.manual === true ? false : self.manual, searching: true});
        request(params)
            .then(function (response) {
                let members = (response.data && response.data.page) ? response.data.page.content : [];
                let totalIdList = response.data ? response.data.selectedIdList : [];
                let debtList = response.data ? response.data.debtList : [];
                let totalChanged = false;
                if (response.data.page.totalElements !== self.state.total) {
                    totalChanged = true;
                }
                self.setState({
                    page: !totalChanged ? page : 0,
                    size: size,
                    total: response.data.page.totalElements,
                    members,
                    totalIdList,
                    debtList,
                    loading: false,
                    searching: false
                });
            }).catch(function (error) {
            self.setState({loading: false, searching: false});
            showAxiosError(error);
        });
    }

    handleLogout() {
        this.props.handleLogout();

    }

    cancelMemberCreation() {
        this.setState({
            addMemberModal: false,
            addTransferModal: false,
            addPasswordResetModal: false,
            addAccrualModal: false,
            excelDownloadForm: false,
            showTransactionHistoryModal: false,
            selectedMember: null,
        })
    }

    cancelAccrualEditModal() {
        this.setState({
            showEditAccrualModal: false,
            memberId: null
        })
    }

    handleEdit(item) {
        let self = this;
        let params = {
            url: API_BASE_URL + "/uye/" + item.id,
            method: 'get'
        };
        request(params).then(function (response) {
            self.setState({
                selectedMember: response.data,
                addMemberModal: true
            })
        }).catch(function (error) {
            showAxiosError(error);
        });
    }

    handleSendResetPasswordEmail(item) {
        let self = this;
        let params = {
            url: API_BASE_URL + "/uye/" + item.id,
            method: 'get'
        };
        request(params).then(function (response) {
            self.setState({
                selectedMember: response.data,
                addPasswordResetModal: true
            })
        }).catch(function (error) {
            showAxiosError(error);

        });
    }

    handleTransfer(item) {
        let self = this;
        let params = {
            url: API_BASE_URL + "/uye/" + item.id,
            method: 'get'
        };
        request(params).then(function (response) {
            self.setState({
                selectedMember: response.data,
                addTransferModal: true
            })
        }).catch(function (error) {
            showAxiosError(error);
        });
    }

    handleAccruals(item) {
        let self = this;
        let params = {
            url: API_BASE_URL + "/uye/" + item.id,
            method: 'get'
        };
        request(params).then(function (response) {
            self.setState({
                selectedMember: response.data,
                addAccrualModal: true
            })
        }).catch(function (error) {
            showAxiosError(error);
        });
    }

    handleTransactionHistory(item) {
        let self = this;
        let params = {
            url: API_BASE_URL + "/uye/" + item.id,
            method: 'get'
        };
        request(params).then(function (response) {
            self.setState({
                selectedMember: response.data,
                showTransactionHistoryModal: true
            })
        }).catch(function (error) {
            showAxiosError(error);
        });
    }

    handleEditAccrual(item) {
        let self = this;
        self.setState({memberId: item.id, showEditAccrualModal: true});
    }

    addNew() {
        let self = this;
        self.setState({
            selectedMember: null,
            addMemberModal: true
        })
    }

    arrangeDataSet() {
        let dataSet = {};
        dataSet.headers = headerContent.memberContent;
        dataSet.sheetName = 'Üye Listesi';
        dataSet.uuid = create_UUID();
        dataSet.idList = this.state.totalIdList;
        return dataSet;
    }

    async handleDownloadExcel() {
        let self = this;
        self.setState({excelDownloadForm: true});
    }

    handleSearch(searchQuery, fromForm) {
        let page = 0;
        if (fromForm) {
            page = this.state.page;
        }
        this.setState({
            searchQuery,
            searching: true,
        }, () => this.listMembers(this.state.accessor, this.state.direction, page, this.state.size))
    }

    handleMenuClick(e) {
        let self = this;

        if (e.key === '1') {
            this.handleEdit(self.state.selectedItem);
        } else if (e.key === '2') {
            this.handleSendResetPasswordEmail(self.state.selectedItem);
        } else if (e.key === '3') {
            this.handleTransfer(self.state.selectedItem);
        } else if (e.key === '4') {
            this.handleAccruals(self.state.selectedItem);
        } else if (e.key === '5') {
            this.handleTransactionHistory(self.state.selectedItem);
        } else if (e.key === '6') {
            this.handleEditAccrual(self.state.selectedItem);
        }
    }

    checkMemberHasDebt(id) {
        let debt = false;
        if (this.state.debtList && id) {
            for (const item of this.state.debtList) {
                if (item.id === id) {
                    debt = item.debt;
                }
            }
        }
        return debt;
    }

    checkBelgeDate(item) {
        let ret = false;
        if (moment(item.mezuniyetTarihi, "YYYY-MM-DD", true).isValid()) {
            let now = moment().format('YYYY-MM-DD');
            let diff = moment(now).diff(item.mezuniyetTarihi, 'days');
            if (diff >= 0)
                ret = true;
        }
        return ret;
    }

    render() {
        let self = this;
        let branchSelectdata;
        let citySelectdata;
        let subDivisonSelectedData;
        const {members} = this.state;
        const {branches} = this.state;
        const {cities} = this.state;
        let cityList = (this.props.currentUser.realm === 0) ? filterCities(cities, 1000) : filterCities(cities, this.props.currentUser.realm);
        let subDivisionList = filterSubDivisions(this.state.subdivisions);
        const uyelikDurumu = [
            {value: null, label: "Tümü"},
            {value: 'true', label: "AKTİF"},
            {value: 'false', label: "PASİF"},
        ];

        const uyeCalisiyor = [
            {value: null, label: "Tümü"},
            {value: 'true', label: "HAYIR"},
            {value: 'false', label: "EVET"},
        ];
        const calismaBelgeli = [
            {value: null, label: "Tümü"},
            {value: 'true', label: "EVET"},
            {value: 'false', label: "HAYIR"},
        ];
        const mesulMudur = [
            {value: null, label: "Tümü"},
            {value: 'true', label: "EVET"},
            {value: 'false', label: "HAYIR"},
        ];
        const temsilci = [
            {value: null, label: "Tümü"},
            {value: 'true', label: "EVET"},
            {value: 'false', label: "HAYIR"},
        ];
        const unemployed = [
            {value: null, label: "Tümü"},
            {value: 'true', label: "EVET"},
            {value: 'false', label: "HAYIR"},
        ];
        const taahhutList = [
            {value: null, label: "Tümü"},
            {value: 'true', label: "EVET"},
            {value: 'false', label: "HAYIR"},
        ];
        const belgeTuru = [
            {value: null, label: "Tümü"},
            {value: 'DIPLOMA', label: "DİPLOMA"},
            {value: 'RUHSATNAME', label: "RUHSATNAME"},
            {value: 'GECICI_MEZUNIYET', label: "GEÇİCİ MEZUNİYET BELGESİ"},
        ];
        const tranferred = [
            {value: null, label: "Tümü"},
            {value: 'true', label: "EVET"},
            {value: 'false', label: "HAYIR"},
        ];

        const header = [
            {value: null, label: "Tümü"},
        ];
        branches ? branchSelectdata = header.concat(branches) : branchSelectdata = header;
        cityList ? citySelectdata = header.concat(cityList) : citySelectdata = header;
        subDivisonSelectedData = subDivisionList ? header.concat(subDivisionList) : header;
        const menu = (
            <Menu onClick={self.handleMenuClick}>
                {
                    self.state.selectedItem &&
                    <Menu.Item key="6">
                        Aidat Düzenle
                    </Menu.Item>
                }
                {
                    self.state.selectedItem &&
                    <Menu.Item key="4">
                        Borç Tahsilatı
                    </Menu.Item>
                }
            </Menu>
        );

        const columns = [
            {
                Header: "Ad",
                accessor: "ad",
                Cell: (item) => {
                    return <label>
                        {item.ad}
                    </label>
                }
            },
            {
                Header: "Soyad",
                accessor: "soyad",
            },
            {
                Header: "Sicil No",
                accessor: "odaSicilNo",
                Cell: (item) => {
                    return <label>
                        {item.odaSicilNo}
                    </label>
                }
            },
            {
                Header: "TCKN",
                accessor: "tcKimlikNo",
                Cell: item => (
                    <label>{item.tcKimlikNo}</label>)
            },
            {
                Header: "Oda İlişiği",
                accessor: "",
                Cell: item => (
                    <label>{item.uyelikAktif ? 'AKTİF' : 'PASİF'}</label>
                )
            },
            {
                Header: "Üyelik Dondur",
                accessor: "",
                Cell: item => (
                    <label>{item.uyeCalisiyor ? 'HAYIR' : 'EVET'}</label>
                )
            },
            {
                Header: "Firma",
                accessor: "muesseseAdi",
                Cell: item => (
                    <label>{item.muesseseAdi ? item.muesseseAdi : '-'}</label>)
            },
            {
                Header: "İl",
                accessor: "",
                Cell: item => (
                    <label>{item.city.ad && item.city.ad}</label>
                )
            },
            {
                Header: "Kayıt / İlişik Kesme / Üyelik Dondurma Tarihleri",
                accessor: "",
                Cell: item => (
                    <div style={{margin: "0px", fontSize: "12px"}}>
                        {item.odaKayitTarihi ? "KT: " + new Date(item.odaKayitTarihi.toString()).toLocaleDateString('tr') : ""}

                        {item.uyelikSonlanmaTarihi ? <br/> : ""}

                        {item.uyelikSonlanmaTarihi ? "İKT: " + new Date(item.uyelikSonlanmaTarihi.toString().substring(0, item.uyelikSonlanmaTarihi.toString().indexOf('T'))).toLocaleDateString('tr') : ""}

                        {item.uyelikDondurmaTarihi ? <br/> : ""}

                        {item.uyelikDondurmaTarihi ? "ÜDT: " + new Date(item.uyelikDondurmaTarihi.toString().substring(0, item.uyelikDondurmaTarihi.toString().indexOf('T'))).toLocaleDateString('tr') : ""}

                    </div>


                )
            },
            {
                Header: "Oda",
                accessor: "",
                Cell: item => (
                    <label>{item.city.oda.ad && item.city.oda.ad.toString().substring(0, 25) + "..."}</label>
                )
            }
        ];

        if (this.props.currentUser.realm === 0 ){
            columns.push({
                Header: "İşlemler",
                accessor: "",
                sortable: false,
                Cell: item => (
                    <div>
                        <Dropdown overlay={menu} trigger='click' onClick={() => self.setState({selectedItem: item})}>
                            <Button style={{
                                background: '#3b6b96',
                                height: '30px',
                                width: '100px',
                                color: 'white',
                                borderRadius: '0.375em',
                                fontSize: "12px",
                            }}>
                                Seçiniz<Icon type="down"/>
                            </Button>
                        </Dropdown>
                    </div>
                )
            });
        }

        const fields = [
            {
                label: "Ad",
                accessor: "ad",
                type: "text",
                operator: "=",
            },
            {
                label: "Soyad",
                accessor: "soyad",
                type: "text",
                operator: "=",
            },
            {
                label: "Oda Sicil No",
                accessor: "odaSicilNo",
                type: "text",
                operator: "=",
            },
            {
                label: "Oda",
                accessor: "city.oda.id",
                type: "select",
                operator: "=",
                selectData: branchSelectdata,
            },
            {
                label: "TC Kimlik No",
                accessor: "tcKimlikNo",
                type: "text",
                operator: "=",
            },
            {
                label: "İl",
                accessor: "city.id",
                type: "select",
                operator: "=",
                selectData: citySelectdata,
            },
            {
                label: "Firma Adı",
                accessor: "muesseseAdi",
                type: "text",
                operator: "=",
            },
            {
                label: "İlçe",
                accessor: "citySubDivision",
                type: "select",
                operator: "=",
                selectData: subDivisonSelectedData,
            },
            {
                label: "Telefon No",
                accessor: "telefonNo",
                type: "text",
                operator: "=",
            },
            {
                label: "Oda İlişiği",
                accessor: "uyelikAktif",
                type: "select",
                operator: "=",
                selectData: uyelikDurumu,
            },
            {
                label: "Mezuniyet Belge Tipi",
                accessor: "belgeTuru",
                type: "select",
                operator: "=",
                selectData: belgeTuru,
            },
            {
                label: "Üyelik Dondur",
                accessor: "uyeCalisiyor",
                type: "select",
                operator: "=",
                selectData: uyeCalisiyor,
            },
            {
                label: "Çalışma Belgeli Personel",
                accessor: "calismaBelgeli",
                type: "select",
                operator: "=",
                selectData: calismaBelgeli,
            },
            {
                label: "Mesul Müdür",
                accessor: "mesulMudur",
                type: "select",
                operator: "=",
                selectData: mesulMudur,
            },
            {
                label: "Temsilci",
                accessor: "temsilci",
                type: "select",
                operator: "=",
                selectData: temsilci,
            },
            {
                label: "İşsiz",
                accessor: "unemployed",
                type: "select",
                operator: "=",
                selectData: unemployed,
            },
            {
                label: "Transfer",
                accessor: "isTransferred",
                type: "select",
                operator: "=",
                selectData: tranferred,
            },
            {
                label: "Taahhütlü",
                accessor: "taahhut",
                type: "select",
                operator: "=",
                selectData: taahhutList,
            },
            {
                label: "Oda Kayıt Tarihi(..'den Sonra) ",
                accessor: "min_odaKayitTarihi", //min_xxx MUST ALWAYS come before the max_xxx, if it exists.
                type: "date",
                operator: ">=",
            },
            {
                label: "Oda Kayıt Tarihi(..'den Önce)",
                accessor: "max_odaKayitTarihi", //min_xxx MUST ALWAYS come before the max_xxx, if it exists.
                type: "date",
                operator: "<=",
            },
            {
                label: "Üyelik Sonlanma Tarihi(..'den Sonra) ",
                accessor: "min_uyelikSonlanmaTarihi", //min_xxx MUST ALWAYS come before the max_xxx, if it exists.
                type: "datetime",
                operator: ">=",
            },
            {
                label: "Üyelik Sonlanma Tarihi(..'den Önce)",
                accessor: "max_uyelikSonlanmaTarihi", //min_xxx MUST ALWAYS come before the max_xxx, if it exists.
                type: "datetime",
                operator: "<=",
            },
            {
                label: "Üyelik Dondurma Tarihi(..'den Sonra) ",
                accessor: "min_UyelikDondurmaTarihi", //min_xxx MUST ALWAYS come before the max_xxx, if it exists.
                type: "datetime",
                operator: ">=",
            },
            {
                label: "Üyelik Dondurma Tarihi(..'den Önce)",
                accessor: "max_UyelikDondurmaTarihi", //min_xxx MUST ALWAYS come before the max_xxx, if it exists.
                type: "datetime",
                operator: "<=",
            },

        ];

        return (

            <div className="row baseBackground">
                {
                    (this.state.isLoading) &&
                    <div className="loader">
                        <LoadingIndicator/>
                    </div>
                }
                <div className="col-md-12 satirBasi">
                    <div className="card-header ">
                            <h4 className="card-title">Oda İlişiği Kesilmiş Borçlu Üyeler</h4>
                    </div>
                    <div className="card-body mt-1">
                        <div className=" ">
                            <div className="" style={{marginTop: '10px', marginBottom: '10px'}}>
                                <DetailedSearch fields={fields}
                                                loading={this.state.searching}
                                                onSearch={this.handleSearch}/>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <Table
                            loading={this.state.loading}
                            loadingText="Kayıtlar getiriliyor..."
                            content={members}
                            total={this.state.total}
                            page={this.state.page}
                            manual={this.state.manual}
                            size={this.state.size}
                            options={["5", "10", "20", "50", "100"]}
                            columns={columns}
                            fetchData={this.listMembers}
                            style = {{width : "100%"}}
                        />
                    </div>
                    <button type="button" data-toggle="tooltip" data-placement="bottom"
                            title="Excel İndir" disabled={this.state.isLoading}
                            style={{
                                background: 'linear-gradient(#129a30, #116128)',
                                height: '40px',
                                width: '160px',
                                float: 'right',
                                marginRight: '30px',
                                color: 'white',
                                borderRadius: '0.375em',
                            }}
                            rel="tooltip" className="TekBtn excel "

                            onClick={() => this.handleDownloadExcel()}>
                        ÜYE EXCEL İNDİR
                    </button>
                </div>
                <Modal isOpen={this.state.excelDownloadForm} size="lg" className="ust">
                    <ModalHeader toggle={this.cancelMemberCreation}>Excel İndirme Sütun Düzenle</ModalHeader>
                    <ModalBody>
                        <ExcelDownloadForm cancelProcess={this.cancelMemberCreation}
                                           content={headerContent.memberContent}
                                           data={this.arrangeDataSet()}
                                           url={API_BASE_URL + '/uye/downloadReport'}
                        />
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.showEditAccrualModal} size="lg" className="ust">
                    <ModalHeader toggle={this.cancelAccrualEditModal}>Üye Aidat Değişikliği </ModalHeader>
                    <ModalBody>
                        <MemberAccrualsModal cancelProcess={this.cancelAccrualEditModal}
                                             currentUser={this.props.currentUser}
                                             branches={this.state.branches}
                                             memberId={this.state.memberId}
                                             cities={this.state.cities}
                        />
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.addAccrualModal} size="lg" className="ust">
                    <ModalHeader toggle={this.cancelMemberCreation}>
                        Borç Tahsilatı
                    </ModalHeader>
                    {<ModalBody style={{'max-height': 'calc(100vh - 210px)', 'overflow-y': 'auto'}}>
                        <IncomeForm cancelProcess={this.cancelMemberCreation}
                                    selectedMember={this.state.selectedMember}
                                    mode={this.state.mode}
                                    currentUser={this.props.currentUser}
                                    handleSearch={this.handleSearch}
                                    transactionTypes={this.state.transactionTypes}
                                    transactionChannels={this.state.transactionChannels}
                                    channel="member-accruals"
                        />
                    </ModalBody>
                    }
                </Modal>
            </div>
        )
    }
}

export default PassiveMemberListWithDebit



// WEBPACK FOOTER //
// ./src/page/memberList/PassiveMemberListWithDebit.js